(function () {
  'use strict';

  var ICON_SELECTOR = '.social-icon-img, .contact-icon';

  function darkVariant(url) {
    if (!url) return url;
    return url
      .replace(/mc(\.[a-z0-9]+)(\?.*)?$/i, 'mn$1$2')
      .replace(/_mc(\.[a-z0-9]+)(\?.*)?$/i, '_mn$1$2')
      .replace(/-mc(\.[a-z0-9]+)(\?.*)?$/i, '-mn$1$2');
  }

  function applyIconTheme() {
    var isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    document.querySelectorAll(ICON_SELECTOR).forEach(function (img) {
      if (!img || !img.src) return;
      if (!img.dataset.lightSrc) img.dataset.lightSrc = img.src;
      var lightSrc = img.dataset.lightSrc;
      var target = isDark ? darkVariant(lightSrc) : lightSrc;
      if (target && img.src !== target) img.src = target;
    });
  }

  function init() {
    applyIconTheme();
    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme';
      });
      if (shouldUpdate) applyIconTheme();
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
